import { observable, decorate, computed } from 'mobx';
import _ from 'lodash';
import { authUserState } from './common';
import { checkRights } from '../functions';
import { dashboardsTitles } from '../dictionary';
import arrayMove from 'array-move';
import moment from 'moment';

const ContentTypes = [
	{ Id : 1, Name : "Content", Right : "ManageContent" },
	{ Id : 2, Name : "Stock", Right : "ManageSaleOuts" },
	{ Id : 3, Name : "Documents", Right : "ManageContent" },
	{ Id : 4, Name : "News", Right : "ManageNews" }
]

export class ContentState {
	constructor(dashboardId, type) {
		this.DashboardId = dashboardId || -1;
		this.Type = type || "";

		this.Roles = [];
		this.Filials = [];
		this.Brands = [];

		this.IsSendRequest = false;
		this.ContentType = "";
	}

	/** Заголовок текущей контентной страницы из общего словаря или исходный тип страницы */
	get PageTitle () { return dashboardsTitles[this.Type] || this.Type; }

	ContentPageIds = [3,4,5,6,8,15,16,17,23,24,65,66,71,72,73,74,79,80,84,85,92,94,149,150,151,152,153,154,155,156,157];

	
	get isDocs () { return this.ContentType === "Documents"; }
	get isNews () { return this.ContentType === "News"; }
	get isStock () { return this.ContentType === "Stock"; }

	get CanManage () {
		if (this.ContentType === "") return false;
		var type = _.find(ContentTypes, { Name : this.ContentType });
		return type ? checkRights(type.Right) : false;
	}

	/**
	 * Функция, разбирающая ответ от сервера со всем контентом на странице
	 * @param {[object]} data ответ от сервера
	 * @param {string} type тип контента
	 * @param {boolean} isWidget флаг того, что данные размещаются в виджите
	 */
	setContent (data, id, isWidget) {
		this.ContentType = data.Success ? data.Type : ""; 

		var pages = data.Success ? _.filter(data.Content, (item) => {
			// TODO: исправить фильтрацию по должности согласно тестам:
			// обычный контент не должен отсеиваться по Roles, а новости должны быть доступны только текущей должности.
			var active = this.CanManage ? true : item.Active,
				filial = this.CanManage ? true : _.indexOf(item.Filials, authUserState.Filial.Id) !== -1,
				role = this.isNews || (this.CanManage && !this.Widget) ? true :
					_.indexOf(item.Roles, authUserState.Role.Id) !== -1;
			
					return active && filial && role;
		}) : []

		// TODO: оставить здесь только базовую фильтрацию статей по доступности.
		// Формирование Group, FilialsId, RolesId и названий филиалов и должностей перенести в модель.
		pages = _.map(pages, (item) => {
			var allFilials = _.isEmpty(_.difference(_.map(this.Filials, "Id"), item.Filials)),
				allRoles = _.isEmpty(_.difference(_.map(this.Roles, "Id"), item.Roles));

			return _.extend(item, {
				FilialsId : item.Filials,
				RolesId : item.Roles,
				Filials : _.isNull(item.Filials) || _.isEmpty(item.Filials) ? "Недоступно" 
					: allFilials ? "Всем" : _.compact(_.map(item.Filials, (id) => {
						var filial = _.find(this.Filials, { Id : id });
						return filial ? filial.Name : null
					})).join(", "),
				Roles : _.isNull(item.Roles) || _.isEmpty(item.Roles) ? "Недоступно" 
					: allRoles ? "Всем" : _.compact(_.map(item.Roles, (id) => {
						var role = _.find(this.Roles, { Id : id });
						return role ? role.Name : null
					})).join(", "),
				Group : this.isNews ? "Новости" : item.Group
			})
		})
		
		if (isWidget && this.isNews) pages = _.take(_.sortBy(pages, (v) => { return -moment(v.LastUpdate)}), 3);

		this.Glossary = new Glossary(pages, this.ContentType, id);
		this.IsSendRequest = true;
	}
}

decorate(ContentState, {
	Type: observable,		// Тип текущей страницы
	Roles: observable,		// Список должностей
	Filials: observable,	// Список филиалов
	Brands: observable,		// Список брендов

	IsSendRequest: observable,	// Флаг Отправки запроса
	ContentType: observable,	// Тип Контента
	
	Glossary : observable,  // Содержание страницы

	PageTitle: computed,	// Заголовок текущей страницы
	CanManage : computed
});
export class Glossary {
	/**
	 * @param {[object]} pages страницы контента, ответ от сервера
	 * @param {string} type тип контента
	 * @param {number} id ID страницы, которую необходимо открыть при загрузке
	 */
	constructor(pages, type, id) {
		this.AllPages = !_.isUndefined(pages) && !_.isNull(pages) ? pages : [];
		this.SearchString = "";
		this.Type = type ? type : "Content";
		this.setArticle(id);
	}

	get Pages () {
		if (_.isEmpty(this.AllPages)) return [];

		var pages = this.SearchString === "" ? this.AllPages : _.filter(this.AllPages, (v) => {
			var title = _.toLower(v.Name),
				text = _.toLower(v.Text);

			return title.indexOf(_.toLower(this.SearchString)) !== -1 || text.indexOf(_.toLower(this.SearchString)) !== -1;
		});

		pages = _.map(pages, (v) => {
			return {
				Id : v.Id,
				Name : v.Name,
				Active : v.Active,
				GroupId : v.GroupId,
				Group : v.Group,
				GroupOrder : v.GroupOrder,
				Order : v.Order,
				LastUpdate : v.LastUpdate,
				UserName : v.UserName
			}
		})
		
		var groups =  _.sortBy(_.map(_.groupBy(pages, "GroupId"), (pages) => {
			return {
				Id : _.head(pages).GroupId,
				Name : _.head(pages).Group,
				Order : _.head(pages).GroupOrder,
				Pages : this.Type === "News" ? _.sortBy(pages, (v) => { return -moment(v.LastUpdate) }) 
					: _.sortBy(pages, "Order")
			}
		}), "Order");

		return groups
	}

	get MobilePages () {
		if (_.isEmpty(this.Pages)) return [];

		return _.map(this.Pages, (group) => {
			return {
				Value : group.Name,
				List : _.map(group.Pages, (item) => { return { Key : item.Id, Value : item.Name } })
			}
		})
	}

	/**
	 * Сбор данных с формы поиска по тексту
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Открытие выбранной статьи
	 * - Если передан ID открывает по ID в режиме чтения
	 * - Если ID=-1 открывает новую статью для редактирования
	 * - Если не передан ID и это «Новости» открывают последнюю новость в режиме чтения
	 * - Если не передан ID и не новости открывают первую в порядке сортировки в режиме чтения
	 * @param {number} id ID статьи
	 */
	setArticle(id) {
		this.Article = undefined;
		if (!_.isUndefined(id) && _.isNumber(id)) {
			var article = _.find(this.AllPages, { Id : id })
			if (!_.isUndefined(article)) this.Article = new Article(article, this.Type, id === -1);
		} else {
			var pages = [];
			if (this.Type === "News") pages = _.sortBy(this.AllPages, (v) => {return -moment(v.LastUpdate);});
			else pages = _.sortBy(this.AllPages, ["GroupOrder", "Order"]);

			this.Article = new Article(_.head(pages), this.Type, false);
		}
	}

	/**
	 * Выбор группы для редактирования
	 * @param {number} id ID группы
	 */
	setGroup(id) {
		this.Group = undefined;
		var group = _.find(this.Pages, { Id : id });
		if (!_.isUndefined(group)) this.Group = new Group(group, this.Type);
	}

	/** открытие окна создания новой группы */
	addGroup() { this.Group = new Group ({ Id : -1 }, this.Type); }

	/** Добавление новой группы в список и открытие окна создания статьи */
	addGroupToList() {
		this.SearchString = "";

		var group = this.Group,
			article = {
				Active : true,
				Id : -1,
				Name : "Новая статья",
				Group : group.Name,
				GroupId : -1,
				GroupOrder : this.Pages.length,
				Order : 0
			}

		this.AllPages.push(article);
		this.Group = undefined;
		this.setArticle(-1);
	}

	/**
	 * Добавление новой статьи в группу
	 * @param {number} id ID группы, куда добавляется статья
	 */
	addArticleToGroup(id) {
		var group = _.find(this.Pages, { Id : id });
		if (_.isUndefined(group)) return false;
		
		var article = {
			Active : true,
			Id : -1,
			Name : "Новая статья",
			Group : group.Name,
			GroupId : group.Id,
			GroupOrder : group.Order,
			Order : group.Pages.length
		}

		this.AllPages.push(article);
		this.setArticle(-1);
	}

	/**
	 * Удалить новую несохраненную статью из группы
	 */
	clearEmptyArticleFromGroup () {
		_.remove(this.AllPages, { Id : -1 });
		this.setArticle();
	}

	/**
	 * Сбор данных для пересортировки порядка статей в группе
	 * @param {number} id ID редактируемой группы
	 * @param {{ oldIndex: number, newIndex: number }} sortParams параметры внутренней фнкции пересортировки
	 * @returns {{ Group : number, Name : string, ContentIds: string, Dashboard : number }}
	 */
	changeOrderPages(id, sortParams) {
		var group = _.find(this.Pages, { Id : id });
		if (_.isUndefined(group)) return false;

		group.Pages = arrayMove(group.Pages, sortParams.oldIndex, sortParams.newIndex);

		return {
			Group : group.Id,
			Name : group.Name,
			ContentIds : _.map(group.Pages, "Id").join(","),
			Dashboard : authUserState.DashboardId,
		}
	}

	/**
	 * Сбор данных для пересортировки порядка групп
	 * @param {{ oldIndex: number, newIndex: number }} sortParams параметры внутренней функции пересортировки
	 * @returns {{ GroupIds : string }}
	 */
	changeOrderGroups (sortParams) {
		var groups = arrayMove(this.Pages, sortParams.oldIndex, sortParams.newIndex);
		return {
			GroupIds : _.map(groups, "Id").join(",")
		}
	}
}
decorate(Glossary, {
	AllPages : observable,
	Article : observable,
	Group : observable,
	SearchString : observable,
	Type : observable
})

export class Article {
	/**
	 * @param {object} article статья
	 * @param {string} type тип контента по странице
	 * @param {boolean} editMode режим редактирования
	 */
	constructor(article, type, editMode) {
		this.Active = article && !_.isUndefined(article.Active) ? article.Active : true;
		this.Brand = article && article.Brand ? article.Brand : "";
		this.BrandId = article && article.BrandId ? article.BrandId : 0;
		this.CanPrint = article && article.CanPrint ? article.CanPrint : false;
		this.Filials = article && article.Filials ? article.Filials : "";
		this.FilialsId = article && article.FilialsId &&!_.isNull(article.FilialsId) ? article.FilialsId : [];
		this.Roles = article && article.Roles ? article.Roles : "";
		this.RolesId = article && article.RolesId && !_.isNull(article.RolesId) ? article.RolesId : [];
		this.Id = article && article.Id ? article.Id : -1;
		this.Name = article && article.Name && article.Id !== -1 ? article.Name : "";
		this.Group = article && article.Group ? article.Group : "";
		this.GroupId = article && article.GroupId ? article.GroupId : -1;
		this.GroupOrder = article && article.GroupOrder ? article.GroupOrder : 0;
		this.Order = article && article.Order ? article.Order : 0;
		this.Push = article && article.Push ? article.Push : false;
		this.LastUpdate = article && article.LastUpdate ? article.LastUpdate : "";
		this.Text = article && article.Text ? article.Text : "";
		this.UserName = article && article.LastUpdate ? article.UserName : "";

		this.EditMode = editMode ? editMode : false;
		this.ErrorCode = "";
		this.ButtonLoading = false;
		this.Type = type ? type : "Content";
	}

	get IsContent() { return this.Type === "Content"; }
	get IsDocs() { return this.Type === "Documents"; }
	get IsNews() { return this.Type === "News"; }
	get IsStock() { return this.Type === "Stock"; }

	/**
	 * Сбор данных с формы редактирования статьи
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Сбор данных для запроса сохранения статьи
	 * @returns {object} данныи статьи
	 */
	getData () {
		var type = _.find(ContentTypes, { Name : this.Type }),
			data = {
				Active : this.Active,
				CanPrint : this.CanPrint,
				FilialsId : _.isEmpty(this.FilialsId) ? "" : this.FilialsId.join(","),
				Id : this.Id,
				Name : this.Name,
				Text : this.Text,
				GroupId : this.GroupId,
				GroupDashboard : authUserState.DashboardId, 
				Order : this.Order,
				GroupType : type ? type.Id : 1
			}

		if (this.IsNews) {
			data.RolesId = _.isEmpty(this.RolesId) ? "" : this.RolesId.join(",");
			data.Push = this.Push;
		} else if (this.IsDocs) 
			data.CanPrint = this.CanPrint;
		else if (this.IsStock)
			if (this.BrandId > 0) data.BrandId = this.BrandId;

		if (this.GroupId === -1) data.GroupName = this.Group;

		return data;
	}
}
decorate(Article, {
	BrandId: observable,
	CanPrint: observable,
	FilialsId: observable,
	Name: observable,
	Push: observable,
	RolesId: observable,
	Text: observable,

	EditMode : observable,
	ErrorCode : observable,
	ButtonLoading : observable
})

export class Group {
	constructor(group) {
		this.Id = group && group.Id ? group.Id : -1;
		this.Name = group && group.Name ? group.Name : "";
		this.Pages = group && group.Pages ? group.Pages : [];
	}

	/**
	 * Сбор данных с формы редактирования раздела
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/** Сбор данных для отправки на сервер для изменения названия раздела
	 * @returns {{ Group : number, Name : string, ContentIds: string, Dashboard : number }}
	 */
	getData() {
		return {
			Group : this.Id,
			Name : this.Name,
			ContentIds : _.map(this.Pages, "Id").join(","),
			Dashboard : authUserState.DashboardId,
		}
	}
}
decorate(Group, {
	Name : observable	// Название раздела
})

export const contentState = new ContentState();
